import { AccordionSectionPanel, AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import Minus from "@store/Components/Icons/Minus";
import Plus from "@store/Components/Icons/Plus";
import { TYPOGRAPHY } from "@store/theme/design";
import { transitionHoverStyles } from "@store/theme/mixins";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

const _buttonLineHeight = TYPOGRAPHY.lineHeight.base;

const _sectionHeaderButtonBaseStyles = () => {
    return css`
        background-color: ${getColor("common.accent")};
        border: none;
        border-bottom: 0;
        color: ${getColor("text")};
        font-size: ${TYPOGRAPHY.size.smallest};
        font-weight: ${TYPOGRAPHY.weight.bold};
        letter-spacing: ${TYPOGRAPHY.letterSpacing.larger};
        line-height: ${_buttonLineHeight};
        text-transform: uppercase;
        transition: ${transitionHoverStyles("color")};
        padding: 23px;

        ${props =>
            breakpointValuesMediaQueries(
                props.theme,
                [{ values: ["16px", null, "23px"], properties: ["padding"] }],
                mediaOptions.min,
            )}

        &:hover {
            color: ${getColor("primary")};
        }

        &[aria-expanded="true"] {
            background-color: ${getColor("common.accentLight")};
        }
    `;
};

const _sectionHeaderButtonFocusStyles = () => {
    return css`
        &:focus {
            ${_sectionHeaderButtonBaseStyles()}
            outline-color: ${getProp("theme.focus.color")};
            outline-style: ${getProp("theme.focus.style")};
            outline-width: ${getProp("theme.focus.width")};
            outline-offset: -${getProp("theme.focus.width")};
        }
    `;
};

export const accordionFilterSectionProps: AccordionSectionPresentationProps = {
    headerProps: {
        css: css`
            button {
                ${_sectionHeaderButtonBaseStyles()}
                ${_sectionHeaderButtonFocusStyles()}
            }

            ${/* sc-selector */ AccordionSectionPanel} + & {
                margin-top: 1px;

                button {
                    ${_sectionHeaderButtonBaseStyles()}
                    ${_sectionHeaderButtonFocusStyles()}
                }
            }
        `,
    },
    panelProps: {
        css: css`
            overflow-y: auto;
            overflow-x: hidden;
            max-height: 550px;
            border: none;
            background-color: ${getColor("common.accentLight")};

            ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [{ values: ["7px 16px 16px", null, "9px 23px 23px"], properties: ["padding"] }],
                    mediaOptions.min,
                )}
        `,
    },
    toggleIconProps: {
        css: css``,
    },
    collapseIconProps: {
        src: Minus,
        size: 18,
        color: "inherit",
    },
    expandIconProps: {
        src: Plus,
        size: 18,
        color: "inherit",
    },
    toggleTransition: {
        transitionCss: css`
            transition: none;
        `,
        timeout: { enter: 0, exit: 0 },
    },
};
